module.exports = __webpack_public_path__ + "8c993f65f07e12cfeb4c8ea58772ba36.png";